import React from 'react';
import {Route, Routes} from 'react-router';

// common
import Home from '~/pages/common/Home';

/// specific
import PersonalLetter from '~/pages/intent/PersonalLetter';
import PostCard from '~/pages/intent/PostCard';
import ProfessionalLetter from '~/pages/intent/ProfessionalLetter';
import RealPennedLetter from '~/pages/intent/RealPennedLetter';
import SelfMailer from '~/pages/intent/SelfMailer';
import SnapPackMailer from '~/pages/intent/SnapPackMailer';
import ApiErrorHandler from '~/pages/common/ApiErrorHandler';
import Authorize from '~/pages/common/Authorize';

const AppRoutes: React.FC<React.PropsWithoutRef<any>> = () => {
  return (
    <Routes>
      <Route path="/" element={<Home/>}/>
      <Route path="/send-personal-letter" element={<ApiErrorHandler><PersonalLetter/></ApiErrorHandler>}/>
      <Route path="/send-postcard" element={<ApiErrorHandler><PostCard/></ApiErrorHandler>}/>
      <Route path="/send-professional-letter" element={<ApiErrorHandler><ProfessionalLetter/></ApiErrorHandler>}/>
      <Route path="/send-real-penned-letter" element={<ApiErrorHandler><RealPennedLetter/></ApiErrorHandler>}/>
      <Route path="/send-self-mailer" element={<ApiErrorHandler><SelfMailer/></ApiErrorHandler>}/>
      <Route path="/send-snap-pack-mailer" element={<ApiErrorHandler><SnapPackMailer/></ApiErrorHandler>}/>
      <Route path="/authorize" element={<Authorize/>}/>
    </Routes>
  );
};

export default AppRoutes;
